
<style lang="less">
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
}
</style>

<template>
  <div>
 <Modal
    v-model="modalGraphSvg"
    :title="modalGraphSvgTitle"
    width="1400"
    footer-hide
    class-name="vertical-center-modal"
  >
    <div>
      <Carousel v-model="value1" v-if="modalGraphSvg" :autoplay="historyInstall.length>1" :autoplay-speed="2000" dots="outside" arrow="always">
        <CarouselItem v-for="(item, index) in historyInstall" :key="index">
          <Row :gutter="8">
            <i-col span="8" v-for="img in item.historyInstall" :key="img.fileKey">
               <van-image @click="handleImgPreview(img)" v-if="img.fileKey" lazy-load  height="220"  fit="cover" :src="img.fileKey+'?x-oss-process=image/resize,h_220'" />
            </i-col>
          </Row>
        </CarouselItem>
      </Carousel>
    </div>
  </Modal>
  </div>

</template>

<script>

import { Image as VanImage, ImagePreview } from 'vant'
export default {
  components: {
    [VanImage.name]: VanImage
  },
  props: {
    historyInstall: Array
  },
  data () {
    return {
      modalGraphSvg: false,
      modalGraphSvgTitle: '',

      value1: 0
    }
  },
  methods: {
    showhistory (title) {
      this.modalGraphSvgTitle = title
      this.modalGraphSvg = true
    },

    handleImgPreview (img) {
      ImagePreview({
        images: [img.fileKey],
        startPosition: 0,
        closeable: true
      })
    }
  }
}
</script>
